import { render, staticRenderFns } from "./SingleImageCover.vue?vue&type=template&id=7cd3bcaa&scoped=true&"
import script from "./SingleImageCover.vue?vue&type=script&lang=js&"
export * from "./SingleImageCover.vue?vue&type=script&lang=js&"
import style0 from "./SingleImageCover.vue?vue&type=style&index=0&id=7cd3bcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd3bcaa",
  null
  
)

export default component.exports